import {
  CompanyConfigDocument,
  CreateAuthenticationDomainDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useCreateAuthenticationDomain() {
  const session = useCurrentSession()
  const [mutation, { loading }] = useMutation(CreateAuthenticationDomainDocument, {
    extractorFn: (data) => data.authenticationMutations.createAuthenticationDomain,
  })

  const createAuthenticationDomain = useUnsafeCallback(
    (domainName: string) => {
      return mutation({
        variables: {
          companyId: session.company.id,
          domainName: domainName,
        },
        refetchQueries: [CompanyConfigDocument],
      })
    },
    [mutation, session.company.id]
  )

  return {
    createAuthenticationDomain,
    loading,
  }
}
